import {
  PARTNER_PROFILE_AVATAR_CROPPED_FILE_MAX_SIZE,
  PARTNER_PROFILE_AVATAR_MIN_HEIGHT,
  PARTNER_PROFILE_AVATAR_MIN_WIDTH,
} from 'utils/constants';
import {
  ImageSizeViolationError,
  MaximumAllowedFileSizeExceededError,
} from 'utils/errors';
import { checkImageSize } from 'utils/checkImageSize';

export const validatePartnerProfileAvatarInputFile = async (
  file: File
): Promise<void> => {
  const lessThan = await checkImageSize(file, {
    lessThan: {
      width: PARTNER_PROFILE_AVATAR_MIN_WIDTH,
      height: PARTNER_PROFILE_AVATAR_MIN_HEIGHT,
    },
  });

  if (lessThan) {
    throw new ImageSizeViolationError();
  }
};

export const validatePartnerProfileAvatarCroppedFile = async (
  file: File
): Promise<void> => {
  if (file.size > PARTNER_PROFILE_AVATAR_CROPPED_FILE_MAX_SIZE) {
    throw new MaximumAllowedFileSizeExceededError(
      file,
      PARTNER_PROFILE_AVATAR_CROPPED_FILE_MAX_SIZE
    );
  }
};
